import React from 'react';
import '../Routes.css';

function MyBookings() {
  return (
    <div className="page__container">
      <h1 className="page__heading">My Bookings</h1>
    </div>
  );
}

export default MyBookings;
